import { FC } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
import { styles as buttonStyles } from '~/components/Button';
import { styles as textStyles } from '~/components/Text';
import { replaceClassNames } from '~/utils/converters';
import styles from './Hero.module.scss';
import 'swiper/css';
import 'swiper/css/pagination';

interface HeroItem {
    id: string;
    html: string;
    image: string | null;
    imageMobile: string | null;
    content: string | null;
    actions: string[];
    action: string[];
}

interface HeroProps {
    sliderItems: HeroItem[];
}

const Hero: FC<HeroProps> = ({ sliderItems }) => {

    return sliderItems?.length > 0 && (
        <section className={styles.hero}>
            <Swiper
                modules={[Pagination, Autoplay]}
                pagination={{
                    clickable: true,
                    el: `.${styles.custom_pagination}`,
                    bulletClass: styles.dot,
                    bulletActiveClass: styles.dot_active,
                    renderBullet: (index, className) => {
                        return `<span class="${className}"></span>`;
                    }
                }}
                autoplay={{
                    delay: 5000,
                    disableOnInteraction: false,
                }}
                loop={sliderItems?.length > 1}
                className={styles.swiper_container}
            >
                {sliderItems?.map((item, index) => (
                    <SwiperSlide key={index}>
                        <div
                            className={styles.hero_item}
                            dangerouslySetInnerHTML={{
                                __html: replaceClassNames(item.html, {
                                    Hero: styles,
                                    Button: buttonStyles,
                                    Text: textStyles
                                })
                            }}
                        />
                    </SwiperSlide>
                ))}
            </Swiper>
            {sliderItems?.length > 1 && (
                <div className={`${styles.custom_pagination} ${styles.dots}`}></div>
            )}
        </section>
    );
};

export default Hero;
